import React, { useState, useEffect } from 'react';
import {
  Modal, Form, Button, Badge,
} from 'react-bootstrap';
import { Typeahead } from 'react-bootstrap-typeahead';

function GroupEditorModal({
  show,
  onHide,
  data,
  onAssign,
  existingGroups,
}) {
  const [groupName, setGroupName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Reset form when modal opens
  useEffect(() => {
    if (show && data?.currentGroup) {
      setGroupName(data.currentGroup);
    } else {
      setGroupName('');
    }
  }, [show, data]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!groupName.trim()) return;

    setIsSubmitting(true);
    try {
      await onAssign(groupName.trim());
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleGroupSelect = (selected) => {
    if (selected.length > 0) {
      const value = typeof selected[0] === 'string' ? selected[0] : selected[0].label || selected[0];
      setGroupName(value);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <i className="fa fa-users me-2" />
          Assign Group
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Group Name</Form.Label>
            <Typeahead
              id="group-name-typeahead"
              allowNew
              newSelectionPrefix="Create new group: "
              placeholder="Select or create a group..."
              options={existingGroups || []}
              selected={groupName ? [groupName] : []}
              onChange={handleGroupSelect}
              onInputChange={(text) => setGroupName(text)}
            />
            <Form.Text className="text-muted">
              Enter a group name or select from existing groups
            </Form.Text>
          </Form.Group>

          {data?.bookingIds?.length > 0 && (
            <div className="mb-3">
              <small className="text-muted">
                This will update
                {' '}
                <Badge bg="primary">{data.bookingIds.length}</Badge>
                {' '}
                booking(s)
              </small>
            </div>
          )}

          {existingGroups && existingGroups.length > 0 && (
            <div className="mb-3">
              <Form.Label className="small text-muted">Quick Select:</Form.Label>
              <div className="d-flex flex-wrap gap-1">
                {existingGroups.slice(0, 8).map((group) => (
                  <Badge
                    key={group}
                    bg="light"
                    text="dark"
                    className="border"
                    style={{ cursor: 'pointer' }}
                    onClick={() => setGroupName(group)}
                  >
                    {group}
                  </Badge>
                ))}
              </div>
            </div>
          )}
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={isSubmitting}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={handleSubmit}
          disabled={!groupName.trim() || isSubmitting}
        >
          {isSubmitting ? (
            <>
              <i className="fa fa-spinner fa-spin me-2" />
              Assigning...
            </>
          ) : (
            <>
              <i className="fa fa-check me-2" />
              Assign Group
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default GroupEditorModal;
